import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    paddingLeft: 20,
    paddingRight: 75,
    marginBottom: 100,
    [theme.breakpoints.down('lg')]: {
      width: '95%',
      margin: '2vh auto',
      paddingLeft: 0,
      paddingRight: 0,
      marginBottom: 0,
    }
  },
  btn: {
    border: '2px solid black',
    background: 'white',
    color: 'black',
    boxShadow: 'none',
  },
  drawerContent: {
    borderTop: '2px solid #23296F',
    borderRadius: 16,
    overflowX: 'hidden',
    minHeight: 300,
    maxHeight: '70vh',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  rootStyle: {
    background: '#000a8c6b',
  },
  contentDrawer: {
    position: 'relative',
    width: '50%',
    margin: '20px auto',
    display: 'block',
    [theme.breakpoints.down('xs')]: {
      width: '95%',
    },
  },
  titleTests: {
    fontSize: 30,
    fontFamily: 'Poppins',
    textTransform: 'none',
    lineHeight: '36px',
    [theme.breakpoints.down('xs')]: {
      fontSize: 15,
      lineHeight: 1.2,
      marginRight: 40,
    },
  },
  separator: {
    width: '100%',
    height: 1,
    background: '#E4E4F2',
    margin: '25px 0px 25px',
  },
  testCard: {
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #5151512b',
    padding: '15px 25px',
    fontFamily: 'Poppins',
    fontWeight: 400,
    color: '#000A8C',
    margin: '15px 0px',
    cursor: 'pointer',
    transition: 'all 0.4s ease allow-discrete',
    backgroundColor: 'white',
    '&:hover': {
      color: 'white',
      background:
        'linear-gradient(88.68deg, #000A8C 2.25%, #E63C3C 47.27%, #FFDC37 97.75%) 0% 0% no-repeat padding-box',
    },
  },
  subTitleTests: {
    color: '#A9AAB8 !important',
    fontSize: 14,
    fontStyle: 'italic',
  },
  iconBtnImage: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    top: '1.5%',
    right: '1%',
    zIndex: 2,
  },
  modalText: {
    fontSize: 14,
    fontFamily: 'ITC Avant Garde Gothic Std Medium',
  },
  titleTests2: {
    fontSize: 16,
    fontFamily: 'Poppins',
    textTransform: 'none',
    lineHeight: 1.5,
    color: '#151528',
  },
  iconBtnImageLogout: {
    position: 'absolute',
    top: '5%',
    right: '2%',
    zIndex: 2,
    color: '#E63C3C',
    textTransform: 'none',
  },
  contentDrawer2: {
    position: 'relative',
    width: '50%',
    margin: '75px auto 75px',
    display: 'block',
    [theme.breakpoints.down('xs')]: {
      width: '95%',
      margin: '25px auto 20px',
    },
  },
  drawerContent2: {
    borderTop: '2px solid #23296F',
    borderRadius: 16,
    overflowX: 'hidden',
    minHeight: 300,
    maxHeight: '85vh',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  redCaption: {
    color: '#E63C3C',
    background: '#E63C3C33',
    padding: 10,
    fontSize: 16,
    fontStyle: 'italic',
    fontFamily: 'Open Sans',
    marginTop: 20,
    fontWeight: 500,
  },
}));
